/**
 * Parse an ISO8601 timestamp that's cross-browser compatible.
 */
export function parseISO8601Time(iso8601string: string): Date {
  // Safari doesn't accept ISO8601 strings if the date and time are separated by a space
  // It must contain a T
  // See more: https://stackoverflow.com/a/60391306
  return new Date(iso8601string.replace(/\s+/g, 'T'))
}
